import React, { useContext, useEffect, useState } from "react";
import { Card, Col, Typography } from "antd";
import Header from "RefactorSearchPage/Header/web";
import { useTheme } from "shared-components/Styles/ThemeHook";
import { LoadOnScreen } from "shared-components/Components/OnView/web";
import { PropertySimilarsCards } from "../PropertySimilars/PropertySimilarsCards/web";
import { fetchSearchResults } from "src/services/search";
import { PropertyData } from "src/contexts/PropertyData/PropertyDataProvider";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";

import "../styles.less";
import { Footer } from "shared-components/ViewFragments/Footer/web";
import { useWindowSize } from "shared-components/GlobalHooks/useWindowSize";
import { Navigation } from "../Navigation/web";

export const PropertyInactive = ({ listing, mode = "auto" }) => {
	const { theme } = useTheme();
	const screen = useWindowSize();
	const { main_domain } = useContext(ConfigStateContext);
	const [similars, setSimilars] = useState<PropertyData[]>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setLoading(true);
		const fetchSimilarProperties = async () => {

			const propertyParams = {
				operation_type_id: Number(listing?.operation_type?.id),
				property_type_id: [Number(listing?.property_type?.id)],
				minPrice: Math.floor((1 - 0.7) * (listing?.price?.amount || 0)),
				maxPrice: Math.floor((1 + 0.7) * (listing?.price?.amount || 0)),
				currencyID: listing?.price?.currency?.id,
			}

			const projectParams = {
				owner_id: listing?.owner?.id,
				projects: true,
			}

			const data = await fetchSearchResults(
				{
					rows: 10,
					params: listing?.isProject ? projectParams : propertyParams,
					page: 1,
					source: 10,
				},
				main_domain
			);
			setSimilars(data?.searchFast?.data);
			setLoading(false);
		};
		fetchSimilarProperties();
	}, [listing]);

	return (
		<div className="property-detail-container">
			<Header showArrow />

			{screen.lg && (
				<Col span={0} lg={24} className="navigation">
					<div className="container">
						<Navigation type="default" />
					</div>
				</Col>
			)}
			<div
				className="pd-main container pd-container pd-main-row"
				style={{ marginTop: "20px" }}>
				{/* In Active Prop Declaimer */}
				{!listing.active && (
					<>
						<div className="container padding-small is-disabled-property padding">
							<Card
								bodyStyle={{
									background: theme.colors.warningColor,
								}}>
								<Typography.Title
									style={{
										margin: 0,
										textAlign: "center",
									}}
									level={5}>
									{"Este inmueble no está disponible."}
								</Typography.Title>
							</Card>
						</div>

						{((listing.isProject && listing.commercial_units.length > 0) ||
							!listing.isProject) && (
							<Col span={24} className="padding">
								<div className="container similar-container">
									<LoadOnScreen listen={!loading}>
										<PropertySimilarsCards
											avoidFetchingSimilars
											initialProperties={similars}
											id={listing.owner.id}
											mode={mode}
											title={
												mode === "project"
													? "Proyectos de la constructora"
													: null
											}
											ownerId={mode === "project" ? listing.owner.id : null}
										/>
									</LoadOnScreen>
								</div>
							</Col>
						)}
					</>
				)}
				<a
					className="btn-primary"
					href={"/venta/casas-y-apartamentos"}
					style={{ marginTop: "8px", width: "fit-content" }}>
					Ver más propiedades
				</a>
			</div>
			<div className="container">
				<Footer />
			</div>
		</div>
	);
};

